<script lang="ts">
  import { env } from '$env/dynamic/public';
</script>

<section>
  <div class="wrapper">
    <div class="label">
      <span>Designed with </span>
      <span class="logo">
        <svg
          width="73"
          height="22"
          viewBox="0 0 73 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_775_2725)">
            <path
              d="M27.2471 19.9644L27.3039 20.0688H27.4228H27.5347H27.656L27.7121 19.9612L32.7472 10.2945L32.8995 10.0021H32.5699H30.0633H29.9323L29.8799 10.1222L27.549 15.4698L25.0076 10.1164L24.9534 10.0021H24.8269H22.1638H21.8273L21.9881 10.2977L27.2471 19.9644Z"
              fill="#0E0F11"
              stroke="#0E0F11"
              stroke-width="0.4"
            />
            <path
              d="M35.6515 10.2965L35.6514 10.2966C34.83 10.7485 34.1849 11.3691 33.7185 12.1573C33.2513 12.947 33.0192 13.8334 33.0192 14.8106C33.0192 15.8605 33.2539 16.7852 33.7305 17.5775C34.2042 18.3666 34.851 18.9728 35.6673 19.3947C36.4823 19.8158 37.3983 20.0239 38.4109 20.0239C39.4839 20.0239 40.4261 19.7966 41.2298 19.3342C42.0282 18.8747 42.6544 18.25 43.1054 17.4614L43.1055 17.4614C43.5567 16.6721 43.7806 15.7866 43.7806 14.8106C43.7806 13.8351 43.5601 12.9509 43.1169 12.1613L43.1168 12.1611C42.673 11.3722 42.05 10.7506 41.2506 10.2978L41.2505 10.2978C40.4473 9.8435 39.4987 9.62007 38.4556 9.62007C37.4114 9.62007 36.4754 9.8439 35.6515 10.2965ZM36.0586 16.3241L36.0585 16.3239C35.8315 15.9017 35.7122 15.4296 35.7026 14.9026V14.8334C35.7026 14.2945 35.8218 13.8027 36.0598 13.3531L36.0598 13.353C36.2982 12.9019 36.6184 12.5457 37.022 12.2804C37.4199 12.019 37.8734 11.8863 38.3889 11.8863C39.1847 11.8863 39.8269 12.1679 40.3323 12.7306C40.8409 13.2976 41.0979 13.9946 41.0979 14.834C41.0979 15.6734 40.841 16.3661 40.3332 16.9251L40.3331 16.9252C39.8287 17.4811 39.1864 17.759 38.3889 17.759C37.8879 17.759 37.4366 17.63 37.0294 17.3735C36.6195 17.1153 36.2961 16.7668 36.0586 16.3241Z"
              fill="#0E0F11"
              stroke="#0E0F11"
              stroke-width="0.4"
            />
            <path
              d="M47.4896 10.2965L47.4895 10.2966C46.6682 10.7485 46.023 11.3691 45.5567 12.1573C45.0895 12.947 44.8574 13.8334 44.8574 14.8106C44.8574 15.8605 45.0921 16.7852 45.5686 17.5775C46.0423 18.3666 46.6892 18.9728 47.5054 19.3947C48.3204 19.8158 49.2364 20.0239 50.2491 20.0239C51.322 20.0239 52.2643 19.7966 53.0679 19.3342C53.8664 18.8747 54.4925 18.25 54.9436 17.4614L54.9436 17.4614C55.3948 16.6721 55.6188 15.7866 55.6188 14.8106C55.6188 13.8351 55.3982 12.9509 54.9551 12.1613L54.955 12.1611C54.5112 11.3722 53.8881 10.7506 53.0887 10.2978L53.0886 10.2978C52.2854 9.8435 51.3369 9.62007 50.2937 9.62007C49.2496 9.62007 48.3135 9.8439 47.4896 10.2965ZM47.8967 16.3241L47.8966 16.3239C47.6597 15.8833 47.5401 15.3883 47.5401 14.8334C47.5401 14.2945 47.6593 13.8027 47.8973 13.3531L47.8973 13.353C48.1357 12.9019 48.4559 12.5457 48.8595 12.2804C49.2574 12.019 49.711 11.8863 50.2264 11.8863C51.0222 11.8863 51.6644 12.1679 52.1698 12.7306C52.6784 13.2976 52.9354 13.9946 52.9354 14.834C52.9354 15.6734 52.6785 16.3661 52.1707 16.9251L52.1706 16.9252C51.6662 17.4811 51.0239 17.759 50.2264 17.759C49.7261 17.759 49.2747 17.6301 48.8676 17.3735C48.4576 17.1153 48.1342 16.7668 47.8967 16.3241Z"
              fill="#0E0F11"
              stroke="#0E0F11"
              stroke-width="0.4"
            />
            <path
              d="M57.7017 1.93086H57.5017V2.13086V19.5991V19.7991H57.7017H59.9618H60.1618V19.5991V2.13086V1.93086H59.9618H57.7017Z"
              fill="#0E0F11"
              stroke="#0E0F11"
              stroke-width="0.4"
            />
            <path
              d="M63.945 5.88765H63.745V6.08765V10.0243H62.2891H62.0891V10.2243V12.0003V12.2003H62.2891H63.745V19.5992V19.7992H63.945H66.2278H66.4278V19.5992V12.2003H68.7344H68.9344V12.0003V10.2243V10.0243H68.7344H66.4278V6.08765V5.88765H66.2278H63.945Z"
              fill="#0E0F11"
              stroke="#0E0F11"
              stroke-width="0.4"
            />
            <path
              d="M71.6223 18.4624C71.8186 17.6268 71.3036 16.7881 70.4698 16.5904C69.636 16.3927 68.802 16.9116 68.6057 17.7472C68.4094 18.5828 68.9244 19.4215 69.7582 19.6192C70.5919 19.8169 71.426 19.2981 71.6223 18.4624Z"
              fill="#FFBF0B"
              stroke="#FFBF0B"
              stroke-width="0.4"
            />
            <path
              d="M13.9741 1.31834L14.1365 1.02217H13.7987H11.8605H11.7421L11.6851 1.12598L10.8971 2.56254H0.672363H0.326741L0.498961 2.8622L8.88502 17.4537L9.05696 17.7529L9.23109 17.455L15.242 7.17068L15.4178 6.86976H15.0693H10.9296L13.9741 1.31834ZM7.71932 8.97497H11.7552L9.07183 13.5662L3.95833 4.66774H9.74352L7.54395 8.6788L7.38154 8.97497H7.71932Z"
              fill="#FFBF0B"
              stroke="#FFBF0B"
              stroke-width="0.4"
            />
            <path
              d="M9.87762 18.9728L9.82034 19.0724L9.87763 19.1721L10.8578 20.8773L11.0312 21.179L11.2046 20.8773L21.5584 2.86211L21.7306 2.56245H21.385H14.4317H14.3131L14.2562 2.66655L13.3245 4.37176L13.1628 4.66766H13.5H18.099L9.87762 18.9728Z"
              fill="#0E0F11"
              stroke="#0E0F11"
              stroke-width="0.4"
            />
          </g>
          <defs>
            <clipPath id="clip0_775_2725">
              <rect width="73" height="22" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
      <span class="hidden:xs">Create your website using AI today!</span>
    </div>
    <div class="action">
      <a href={`${env.PUBLIC_BASE_URL}/dashboard`}
        >Try now <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.293 12.293L6.707 13.707L13.414 6.99997L6.707 0.292969L5.293 1.70697L9.586 5.99997H0V7.99997H9.586L5.293 12.293Z"
            fill="black"
          />
        </svg>
      </a>
    </div>
  </div>
</section>

<style>
  section {
    align-items: center;
    background: #fee9ab;
    display: flex;
    font-size: 14px;
    justify-content: center;
    position: sticky;
    top: 0;
    z-index: 9999;
  }

  .wrapper {
    align-items: center;
    display: flex;
    grid-gap: var(--spacing-nano);
    height: 48px;
    max-width: 1300px;
  }
  .action {
    flex: 1;
  }
  .logo {
    margin-top: -3.5px;
  }
  .logo svg {
    height: 20px;
    margin-bottom: -2px;
    margin-right: -2px;
  }
  a {
    display: flex;
    align-items: center;
    background: #fcc72c;
    border-radius: 4px;
    border: none;
    box-shadow: unset;
    color: #202123;
    cursor: pointer;
    display: inline-flex;
    outline: none;
    padding: 5px 10px;
    text-decoration: none;
    white-space: nowrap;
  }
  a svg {
    height: 20px;
    margin-left: 10px;
  }
  .label {
    display: inline-flex;
    gap: var(--spacing-nano);
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    section {
      justify-content: flex-start;
      padding: 0 16px;
    }
    a {
      font-weight: 600;
      background: transparent;
      padding: 0 0;
    }
    .wrapper {
      justify-content: space-between;
      width: 100%;
    }
    .hidden\:xs {
      display: none;
    }
  }
</style>
